<template>
  <div>
    <el-row class="panel">
      <el-col :span="24" class="panel-top">
        <el-col :span="20" style="font-size:26px;">
          <div style="float: left;display: flex;align-items: center;justify-content: center;">
            <a @click="showfullscreen" style="cursor: pointer;">
            <img src="../assets/logo4.png" class="logo"> <span style="font-weight: 700;">{{companyName}}</span>
             </a>
            </div>
         <div id="nav" style="float: left;margin-left: 105px;">
            <ul>
              <li class="selected" v-if="false">
                <a href="javascript:" @click="viewMonitor"><i class="el-icon-view"></i><span style="margin-left:3px;">实时监控</span></a>
              </li>
              <li v-for="(item,index) in openTabs" :class="{ selected: openTabID==item.FID }">
                <a href="#">
                  <i :class="item.FIconCls_Vue"></i>
                  <span>{{item.FName}}</span>
                </a>
              </li>
            </ul>
          </div>

        </el-col>
        <el-col :span="4" class="rightbar">
<!-- 
		  <el-badge :value="messageCount" style="line-height:25px;margin-left: 30px;" v-if="true">
            <span class="el-dropdown-link" style="color:#c0ccda;cursor: pointer;">
              <a href="javascript:;" @click="viewMain">
                <img src="../assets/messages.png" class="head" style='margin: 0'>
              </a>
            </span>
          </el-badge>  -->

          <el-dropdown trigger="click">
               <span class="el-dropdown-link" style="color:#fff;cursor: pointer;display: flex;align-items: center">
		      	    	<label>{{sysUserName}}</label>
		       	    	<img src="../assets/qq2.png" class="head"> 
               </span>
            <el-dropdown-menu slot="dropdown" style="left:1250px;margin-top:0">
              <el-dropdown-item @click.native="modifyUser">修改个人资料</el-dropdown-item>
              <el-dropdown-item @click.native="modifyPsw">修改密码</el-dropdown-item>
              <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

		 <span class="full-screen" @click="toggleFullScreen">
            <el-tooltip class="item" effect="dark" :content="isFullScreen ? '退出全屏':'全屏'" placement="bottom">
              <i :class="isFullScreen ? 'el-icon-aim':'el-icon-full-screen'"
                style="width: 1.6rem;height: 1.6rem;vertical-align:middle;margin-right:0;margin-bottom: .8rem;font-size:2rem"></i>
            </el-tooltip>
          </span>

          <audio autoplay="autoplay" :src="audiourl">
          </audio>
        </el-col>
      </el-col>
      <el-col :span="24" class="panel-center">
        <!--<el-col :span="4">-->
        <div class="panel-left menu-left" v-show="showAside">
          <el-menu class="el-menu-vertical-demo" @open="handleopen" @close="handleclose" @select="handleselect"
            theme="light" unique-opened router style="background-color:#fff;height:100%" :collapse="isCollapse"
            :collapse-transition="false">
            <template v-for="(item,index) in getRoutes()" v-if="item.show && !item.hidden">
              <el-submenu :index="index+''">
                <template slot="title"><i :class="item.iconCls"
                    style="color: #48576a"></i><span>{{item.name}}</span></template>
                <el-menu-item v-for="child in item.children" :index="joinPath(child)"
                  v-if="child.show && !child.hidden">{{child.name}}</el-menu-item>
              </el-submenu>
            </template>
          </el-menu>
        </div>

        <div class="dislpayArrow" :class="arrowLeft">
          <a class="pngfix" :class="arrowOpen" href="javascript:void(0);" @click="displaynavbar">
          </a>
        </div>

        <!--</el-col>-->
        <!--<el-col :span="20" class="panel-c-c">-->
        <section class="panel-c-c" :class="centerCss">
          <div class="grid-content bg-purple-light">
            <el-col :span="24" style="margin-bottom:5px;">
              <strong style="width:200px;float:left;color: #475669;">{{$route.name}}</strong>
              <el-breadcrumb separator="/" style="float:right;">
                <el-breadcrumb-item v-for="item in $route.matched">
                  {{ item.name }}
                </el-breadcrumb-item>
              </el-breadcrumb>
            </el-col>
            <el-col :span="24" style="background-color:#fff;box-sizing: border-box;">
              <!--<transition name="fade">-->
              <router-view></router-view>
              <!--</transition>-->
            </el-col>
          </div>
        </section>
        <!--</el-col>-->
      </el-col>
    </el-row>

    <el-dialog top="5%" size="tiny" title="修改密码" :visible.sync="vPsw" v-model="vPsw" :close-on-click-modal="false">
      <el-form :model="formPsw" :rules="rulesPsw" label-width="0px">
        <el-form-item prop="psw1">
          <el-input v-model="formPsw.psw1" placeholder="新密码"></el-input>
        </el-form-item>
        <el-form-item prop="psw2">
          <el-input v-model="formPsw.psw2" placeholder="确认密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="vPsw = false">取 消</el-button>
        <el-button type="primary" @click="savePsw" :loading="loginingPsw">保存</el-button>
      </div>
    </el-dialog>

    <UserEdit ref="userEdit" @onSaveSuc="userEditSaveSuc" homeEdit>
    </UserEdit>
  </div>
</template>

<script>
  import screenfull from 'screenfull'
  import util from '../common/util'
  import UserEdit from './system/User_Edit.vue'
  export default {
    components: {
      UserEdit: UserEdit
    },
    data() {
      return {
        companyName:global.sysParam.companyName,
        sysName:global.sysParam.systemName,
        cacheloading: false,
        ModuleID: 0,
        Modules: [],
        sysUserName: '',
        showAside: true,
        centerCss: "c-left-230",
        arrowOpen: "",
        arrowLeft: "",
        vPsw: false,
        loginingPsw: false,
        formPsw: {},
        audiourl: '',
        rulesPsw: {
          psw1: [{
            required: true,
            message: '请输入密码',
            trigger: 'change'
          }],
          psw2: [{
            required: true,
            message: '请输入密码',
            trigger: 'change'
          }]
        },
        messageCount: 0,
        isFullScreen: false,
        isCollapse: false,
        openTabs:[],
        openTabID:0
      }
    },
    methods: {
      viewMonitor(){
          window.open(global.serverHost_http + "client/fullscreen/index.html")
      },
      userEditSaveSuc(form) {
        global.user = form
      },
      joinPath(menu) {
        if (menu.query) {
          return menu.path + "?" + menu.query
        } else {
          return menu.path
        }
      },
      onSubmit() {
        console.log('submit!');
      },
      handleopen() {
        //console.log('handleopen');
      },
      handleclose() {
        //console.log('handleclose');
      },
      handleselect: function (a, b) {
        if (a == "/monitor") {
          window.open(global.serverHost_http + "client/src/view/monitor.html")
        } else if (a == "/monitor2") {
          window.open(global.serverHost_http + "client/src/view/monitor2.html")
        } else if (a == "/gaodemap-minitor") {
          window.open(global.serverHost_http + "client/src/view/monitormap.html")
        }
        if (a == "/monitor-send") {
          window.open(global.serverHost_http + "client/test/testSend.html")
        }
        if (a == "/monitor-receive") {
          window.open(global.serverHost_http + "client/test/testReceive.html")
        }
      },
      modifyPsw() {
        this.vPsw = true
      },
      modifyUser() {
        this.$refs.userEdit._openEdit(global.user)
      },
      savePsw() {
        if (!this.formPsw.psw1) {
          util.msgWarning("密码不能为空")
          return
        }
        if (this.formPsw.psw1 != this.formPsw.psw2) {
          util.msgWarning("密码不一致")
          return
        }
        util.post("server/system/User.ashx?cmd=ModifyPsw", {
          passWord: this.formPsw.psw1
        }, null, result => {
          util.msgSuc("保存成功")
          this.vPsw = false
        })
      },
      //退出登录
      logout: function () {
        var _this = this;
        this.$confirm('确认退出吗?', '提示', {
          //type: 'warning'
        }).then(() => {
          util.post("Portal.ashx?cmd=Logout")
          global.user = null;
          //global.allRoutes = null;
          _this.$router.push('/login');
        }).catch(() => {

        });
      },
      displaynavbar() {
        // this.showAside = !this.showAside
        this.centerCss = this.centerCss == "c-left-230" ? "c-left-64" : "c-left-230"
        this.arrowOpen = this.arrowOpen == "" ? "open" : ""
        this.arrowLeft = this.arrowLeft == "" ? "arrowLeft" : ""
        this.isCollapse = !this.isCollapse
      },
      getRoutes() {
        return global.allRoutes.filter((item, i) => {
          return item.moduleID == this.ModuleID
        })

      },
      initModule() {
        this.Modules = global.Module.filter((item, i) => {
          for (let route of global.allRoutes) {
            if (item.FID == route.moduleID && route.show) {
              return true
            }
          }
          return false
        })

        if (this.Modules.length > 0) {
          this.ModuleID = this.Modules[0].FID;
        }
      },
      viewMain() {
        this.$router.push({
          path: '/Main'
        });
      },
      getMessageCount() {
        util.get("server/system/Message.ashx?cmd=GetCount", {
          type: 0
        }, null, result => {
          this.messageCount = result.count
          if (result.calltype == 1) {
            this.audiourl = "/static/audios/1.mp3"
          }
          if (result.calltype == 2) {
            this.audiourl = "/static/audios/2.mp3"
          }
          if (result.calltype == 3) {
            this.audiourl = "/static/audios/1.mp3"
            setTimeout(() => {
              this.audiourl = "/static/audios/2.mp3"
            }, 6000)
          }
        })
      },
      clearCache() {
        util.get("server/system/System.ashx?cmd=RemoveCache", {}, null, result => {
          util.msgSuc("清除成功")
        })
      },
      createAllCache() {
        if (this.cacheloading) {
          return
        }
        this.$confirm('缓存整站需要较长时间，确定操作吗?', '提示', {
          //type: 'warning'
        }).then(() => {
          this.cacheloading = true
          util.post("server/system/System.ashx?cmd=CreateAllCache", {}, null, result => {
            var checkIsEndInterval = setInterval(() => {
              util.get("server/system/System.ashx?cmd=GetCreateAllCacheStatus", {}, null, result => {
                if (result.status != 1) {
                  this.cacheloading = false
                  clearInterval(checkIsEndInterval)
                }
              })
            }, 5 * 1000)
          })
        })
      },
      toggleFullScreen() {
        if (!screenfull.enabled) {
          this.$message({
            message: 'you browser can not work',
            type: 'warning'
          })
          return false
        }
        screenfull.toggle()
        this.isFullScreen = !this.isFullScreen
      },
      // 判断全屏
      checkFull() {
        //判断浏览器是否处于全屏状态 （需要考虑兼容问题）
        //火狐浏览器
        var isFull = document.mozFullScreen ||
          document.fullScreen ||
          //谷歌浏览器及Webkit内核浏览器
          document.webkitIsFullScreen ||
          document.webkitRequestFullScreen ||
          document.mozRequestFullScreen ||
          document.msFullscreenEnabled
        if (isFull === undefined) {
          isFull = false
        }
        return isFull;
      },
      showfullscreen(){
         window.location.href=global.serverHost+"client/fullscreen/index.html"
      }
    },
    created() {
      this.initModule()
      window.onresize = () => {
        if (!this.checkFull()) {
          // 退出全屏后要执行的动作
          this.isFullScreen = false;
        }
      }
    },
    mounted() {
      var _that = this
      var user = global.user
      if (user) {
        this.sysUserName = user.FName || '';
      }
      this.getMessageCount()
      global.bus.$on('RefreshMsgCount', this.getMessageCount)

    }
  }

</script>

<style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }

  .panel {
    position: absolute;
    top: 0px;
    bottom: 0px;
    width: 100%;
  }

  .panel-left {
    width: 230px;
    height: 100%;
    overflow: auto
  }

  .panel-top {
    height: 70px;
    line-height: 70px;
    /*background: #1F2D3D;*/
    background: #222b45;
    color: #fff;
  }

  .panel-top .rightbar {
    text-align: right;
    padding-right: 35px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .panel-top .rightbar .head {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    margin-left: 2px;
    float: right;
  }

  .full-screen{
	  cursor: pointer;
	  margin-left: 10px;
  }


  .panel-center {
    background: #FFFFFF;
    position: absolute;
    top: 70px;
    bottom: 0px;
    overflow: hidden;
  }

  .panel-c-c {
    border-left: 3px solid #f5f7f9;
    background: #f5f7f9;
    position: absolute;
    right: 0px;
    top: 0px;
    bottom: 0px;
    overflow-y: scroll;
    padding: 5px 10px;
  }

  .c-left-230 {
    left: 230px;

  }


  .c-left-64 {
    left: 64px;
    transition: width 2s;
  }

  .logout {
    background: url(../assets/logout_36.png);
    background-size: contain;
    width: 20px;
    height: 20px;
    float: left;
  }

  .logo {
    width: 40px;
    float: left;
    margin: 10px 10px 10px 18px;
  }

  .tip-logout {
    float: right;
    margin-right: 20px;
    padding-top: 5px;
  }

  .tip-logout i {
    cursor: pointer;
  }

  .admin {
    color: #c0ccda;
    text-align: center;
  }

  .dislpayArrow {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 230px;
    width: 0px;
    height: 100%;
    z-index: 10;
    transition: all 0.2s ease 0s;
  }

  .arrowLeft {
    left: 64px;
  }

  .dislpayArrow a {
    background: url(../assets/icon_arrow.png) no-repeat 0 0;
    position: absolute;
    display: block;
    width: 17px;
    height: 61px;
    top: 50%;
    margin-top: -30px;
    outline: none;
  }

  .dislpayArrow a:hover {
    text-decoration: none;
    background-position: right 0;
  }

  .dislpayArrow a.open {
    background-position: 0 -61px;
  }

  .dislpayArrow a.open:hover {
    background-position: right -61px;
  }

  #nav ul {
    zoom: 1;
    overflow: hidden;
    list-style: none;
    margin: 15px;
    padding: 0;
    background: none;
  }

  #nav li {
    float: left;
    width: 100px;
    height: 40px;
    line-height: 38px;
    text-align: center;
    border-radius: 11px;
    margin-left: 5px;
  }

  #nav a {
    color: #fff;
    text-decoration: none;
  }

  #nav li:hover {
    display: block;
    background: #334067;
    color: #fff;
  }

  #nav span {
    font-size: 16px;
  }

  #nav i {
    font-size: 16px;
  }

  .selected {
    display: block;
    background: #334067;
    color: #fff;
  }


  .el-menu-item:hover {
    background: #8cb8f1 !important;
    color: #fff;
  }

  .el-submenu__title:hover {
    background: #8cb8f1 !important;
    color: #fff;
  }

  .el-menu-item.is-active {
    background: #5482ee !important;
    color: #fff;
  }

  .el-submenu__title.is-active {
    background: #5482ee !important;
    color: #fff;
  }

  .el-submenu__title i {
    font-size: 16px;
  }

  .el-menu-item {
    height: 50px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Home.vue